import { Layer } from '@deck.gl/core';
import { getAltitudeColorVector, parseColor255 } from '@fe/core';
import { IFlightItem } from '../flights/types';
import { DEFAULT_ROUTE_FLOWN_COLOR, DEFAULT_ROUTE_WIDTH } from '../routes/routes-layer';
import { DeckLayerCreator } from './deck-layer-creator';
import { DeckOverlayPlugin } from './deck-overlay-plugin';
import { AnimatedLineLayer } from './layers/line/animated-line-layer';

const defaultColorVec = parseColor255(DEFAULT_ROUTE_FLOWN_COLOR);

export class DeckRouteFlownLastSegment extends DeckLayerCreator {
    constructor(plugin: DeckOverlayPlugin) {
        super(plugin);
    }

    createLayers(data: IFlightItem[]): Layer[] {
        if (!this.props?.flights.active.visible) {
            return [];
        }

        const { shouldColorize, isVisible } = this.props.routeFlown;

        if (!this.isCoastMode || !isVisible) {
            return [];
        }

        return [
            new AnimatedLineLayer({
                data,
                id: `lastsegment-route-flown`,
                pickable: false,
                wrapLongitude: true,
                widthUnits: 'pixels',
                widthMinPixels: DEFAULT_ROUTE_WIDTH,
                getWidth: DEFAULT_ROUTE_WIDTH,
                positionTexture: this.plugin.positionTexture,
                getId: (x) => x.id,
                getTargetPosition: (x) => this.getFlightPosition(x),
                getColor: (x) =>
                    this.props?.routeFlown.shouldColorize
                        ? getAltitudeColorVector((this.getFlightAltitude(x) ?? 0) / 100)
                        : defaultColorVec,
                updateTriggers: {
                    all: [this.flightsVersion],
                    getColor: [shouldColorize]
                },
                parameters: this.plugin.getRenderingParams()
            })
        ];
    }
}
